import { createInstance } from '@optimizely/react-sdk';
import { Config } from '~/adapters/config/config';
import { createUseFeatureFlag } from '~/contexts/OptimizelyContext';

export const AccountsOptimizely = createInstance({
    sdkKey: Config.ACCOUNTS_OPTIMIZELY_SDK_ACCOUNTS,
    datafileOptions: {
        updateInterval: 300000, // in ms, 300000 is optimizely default
        autoUpdate: true,
        urlTemplate: `${Config.ACCOUNTS_OPTIMIZELY_PROXY_URL}/datafiles/%s.json`,
    },
});

// standard three variants for those Feature Flags which have boolean meaning (on / off)
export type TestControlVariant = 'off' | 'control' | 'test';

// Feature Flags as [key: variant type], all of them can be found in optimizely, but not vice versa (archived flags aren't here anymore)
// https://app.optimizely.com/v2/projects/22136960345/flags/list
export type AccountsFeatureFlags = {
    // binary on/off flags
    designs_page_art_proofs: TestControlVariant;
    design_details_page: TestControlVariant;
    add_to_cart_notification: TestControlVariant;
    team_accounts: TestControlVariant;

    // internal or development flags
    flags_page: TestControlVariant;
};

export const useFeatureFlag = createUseFeatureFlag<AccountsFeatureFlags>();

type TestControlVariantFeatureFlagKeys = {
    [TKey in keyof AccountsFeatureFlags]: AccountsFeatureFlags[TKey] extends TestControlVariant ? TKey : never;
}[keyof AccountsFeatureFlags];

// helper hook for flags which have boolean meaning (on / off)
export const useFeatureFlagEnabled = (flag: TestControlVariantFeatureFlagKeys): boolean => {
    const flagKey = useFeatureFlag(flag);
    return flagKey === 'test';
};
